<div class="card">
    <div class="card-header">
        <i class="fa fa-database"></i>Detalle de Transacción {{log.id}}
        <div class="card-header-actions btn-group" dropdown placement="bottom left">
            <button class="btn btn-sm btn-outline-success" type="button" (click)="resendTransaction()"
                [disabled]="log.status == 'PROCESSED'">
                <i class="fa fa-refresh"></i>&nbsp;Reenviar Transacción
            </button>
        </div>
    </div>
    <div class="card-body">
        <accordion [isAnimated]="true">
            <accordion-group [isOpen]="true">
                <span accordion-heading>
                    <i class='fa fa-pencil'></i> Información General
                </span>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Código de Cliente</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="log.customerCode" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Nombre de Cliente</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="customer.fullName" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Vendedor</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="log.sellerCode" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Nombre del Vendedor</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="log.seller" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Código de Tienda</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="log.branchCode" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Tienda</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="branch.name" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Fecha de creación</b></label>
                    <div class="col-md-9">
                        <input type="datetime" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="log.date" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Tipo</b></label>
                    <div class="col-md-9 text-left">
                        <span
                            [ngClass]="'badge large-font-size '+getBadgeClass(log.collection)">{{log.collection}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label" for="text-input"><b>Estado</b></label>
                    <div class="col-md-9 text-left">
                        <span [ngClass]="'badge large-font-size '+getBadgeClass(log.status)">{{log.status}}</span>
                    </div>

                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Tipo de Error</b></label>
                    <div class="col-md-9 text-left">
                        <span class="badge large-font-size badge-danger">{{log.errorType}}</span>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Mensaje</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control" disabled>
                    </div>
                </div>
            </accordion-group>
            <accordion-group [isOpen]="true"
                [hidden]="log.collection != 'QUOTATION' && log.collection != 'ORDER' && log.collection != 'INVOICE'">
                <span accordion-heading>
                    <i class='fa fa-file'></i> Detalle de Factura y Contrato
                </span>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Orden</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="log.code"
                            disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Factura</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control"
                            [(ngModel)]="log.invoiceNumber" disabled>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Contrato</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="log.loan"
                            disabled>
                    </div>
                </div>
                <pos-list [data]="products" [config]="{title:'code'}"></pos-list>
            </accordion-group>
            <accordion-group [isOpen]="true" [hidden]="log.collection != 'CREDITREQUEST'">
                <span accordion-heading>
                    <i class='fa fa-file'></i> Detalle de Solicitud
                </span>
                <div class="form-group row">
                    <label class="col-md-3 col-form-label"><b>Código de Solicitud</b></label>
                    <div class="col-md-9">
                        <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="log.code"
                            disabled>
                    </div>
                </div>
            </accordion-group>
            <accordion-group [isOpen]="true">
                <span accordion-heading>
                    <i class='fa fa-database'></i> Bitacora de transacciones
                </span>
                <pos-table [data]="innerLogs" [headers]="getLogHeaders()" [itemsPerPage]="8" [badgeDangerValues]="['FAILED',
                'SKIPPED',
                'DELETED']" [badgeWarningValues]="['PROCESSING','SENDFORCSV','SKIPED']"
                    [badgeSecondaryValues]="['UNPROCESSED']"></pos-table>
            </accordion-group>
        </accordion>
    </div>
</div>